module.exports = __webpack_public_path__ + "static/media/eye-light-gray.b6d092a5.svg";